export class ViewerTool {
    icon: string;
    tooltip: string;
    action: () => void;

    constructor(init?: Partial<ViewerTool>) {
        Object.assign(this, init);
    }
}

export interface IViewable {
    scaleToSource(): void;
    scaleToWindow(): void;
    center(): void;
}
